export default {
    setUserData(state,payload){
        state.userData = payload.userData;
    },

    setUsers(state,payload){
        state.users = payload;
    }
};